import makeSlice from '@web/slices/branch/sliceMaker'

const slice = makeSlice()

export default slice.reducer
